// extracted by mini-css-extract-plugin
module.exports = {"sister-companies":"styles-m__sister-companies__3h0aB","logo":"styles-m__logo__X7AtL"};